export default {
	mutateWebsocketMessage(state, message) {
		state.messages.push(message);
	},
}

